import { Outlet } from "@tanstack/react-router";
import { Header } from "./header";
import { Footer } from "./footer";

export function MainLayout({ children }: { children?: React.ReactNode }) {
  return (
    <div className="flex flex-col min-h-screen bg-white font-sans text-brand-dark overflow-x-hidden">
      <Header />
      <main className="flex-1">
        {children || <Outlet />}
      </main>
      <Footer />
    </div>
  );
}